
import { Component, toNative, Vue } from 'vue-facing-decorator';
import { AppRequestInfo } from '@/entities/AppRequestInfo';
import { StoreHelper } from '@/store/StoreHelper';
import { Root, Store } from '@/main';
// Component
import CreateNewEvent from '@/components/EventSetting/EventDetail.vue';
import EventSettingTabs from '@/components/EventSetting/EventSettingTabs/EventSettingTabs.vue';

@Component({
  components: {
    CreateNewEvent,
    EventSettingTabs,
  },
})
class EventSetting extends Vue {
  private storeHelper: StoreHelper = new StoreHelper(Store);
  private reqInfo: AppRequestInfo = this.storeHelper.GetRequestInfoFromStore();

  private mounted() {
    Root.on('reload-eventsettingtab', () => {
      this.reqInfo = this.storeHelper.GetRequestInfoFromStore();
    });
  }
  private ShowEventSettingsPage() {
    if(this.reqInfo.ApplicationId !== 0) {
      return true;
    } else {
      return false;
    }
  }
  private showCreateNew() {
    // select create new event or edit event informtion
    if (this.reqInfo.ApplicationInstanceId > 0) {
      return false;
    } else {
      return true;
    }
  }
}
export default toNative(EventSetting);
